// ─── Formatage date ─────────────────────────────────────────────────────────
export function formatDate(isoString, opts = {}) {
  const defaults = { day: 'numeric', month: 'short', year: 'numeric' };
  return new Date(isoString).toLocaleDateString('fr-FR', { ...defaults, ...opts });
}

export function formatDateTime(isoString) {
  return new Date(isoString).toLocaleString('fr-FR', {
    day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
  });
}

// ─── Formatage montant FCFA ─────────────────────────────────────────────────
export function formatFCFA(amount) {
  if (!amount && amount !== 0) return '—';
  return amount.toLocaleString('fr-FR') + ' F';
}

// ─── Génération ID / QR ─────────────────────────────────────────────────────
export function generateId() {
  return 'COL-' + Date.now().toString().slice(-7);
}

export function generateQR(id) {
  return `QR-${id}`;
}

// ─── Styles réutilisables ───────────────────────────────────────────────────
export const inputStyle = {
  width: '100%',
  padding: '12px 14px',
  border: '2px solid #e2e8f0',
  borderRadius: 12,
  fontSize: 14,
  fontFamily: 'inherit',
  outline: 'none',
  transition: 'border-color 0.2s, box-shadow 0.2s',
  background: '#fafafa',
  color: '#1e293b',
  caretColor: '#1e293b',
  boxSizing: 'border-box',
};

export const labelStyle = {
  display: 'block',
  fontSize: 12,
  fontWeight: 700,
  color: '#475569',
  marginBottom: 6,
  textTransform: 'uppercase',
  letterSpacing: '0.8px',
};

export const focusInput = (e) => {
  e.target.style.borderColor = '#4F46E5';
  e.target.style.boxShadow   = '0 0 0 3px rgba(79,70,229,0.1)';
  e.target.style.background  = '#fff';
};

export const blurInput = (e) => {
  e.target.style.borderColor = '#e2e8f0';
  e.target.style.boxShadow   = 'none';
  e.target.style.background  = '#fafafa';
};
